import type { ICardOnlineTransaction } from "@/modules/card/common/types";
import { CURRENCY } from "@/shared/common/constants";
import { formatDate } from "@/shared/helpers";
import type { ICellProps } from "@ab.uitools/ui-library/components/AdvancedTable/types";
import { Text } from "@ab.uitools/ui-library/components/Text";

interface Props {
  t: (s: string) => string;
}

export const getColumns = ({ t }: Props) => ([
  {
    id: "creation_date",
    header: t("cards.historyTable.date"),
    accessorKey: "creationDate",
    enableHiding: false,
    cell: ({ row }: ICellProps<ICardOnlineTransaction>) => {
      const date = formatDate(row.original?.creationDate);
      return (
        <Text>{date}</Text>
      );
    }
  },
  {
    id: "aim",
    header: t("cards.historyTable.Purpose"),
    accessorKey: "description",
  },
  {
    id: "enter_exit",
    header: t("cards.historyTable.enterExit"),
    accessorKey: "amount",
    enableHiding: false,
    cell: ({ row }: ICellProps<ICardOnlineTransaction>) => {
      const amount = row.original?.amount;
      const currency = row.original?.currency;
      return (
        <Text>{`${amount} ${CURRENCY[currency]?.symbol || currency}`}</Text>
      );
    },
  },
]);
